<template>
  <div>
    <v-card v-if="employee" :class="'pa-5 fw500 mx-auto employee ' + ($vuetify.breakpoint.smAndDown ? 'f12' : 'f14')"
            width="100%" :min-width="minWidth" :max-width="maxWidth" tile flat dark color="#277FAF">
      <div>{{ localStorage.translations.pages.finance['period-table'].employee + ':' }}</div>
      <div>{{ employee }}</div>
      <div>
        {{
          period.weeks ? localStorage.translations.pages.finance['period-table'].weeks + ':' : ''
        }}
      </div>
      <div>{{ period.weeks || '' }}</div>
      <template v-if="period.term">
        <div>{{ localStorage.translations.pages.finance['period-table'].term + ':' }}</div>
        <div>{{ formattingTerms }}</div>
      </template>
    </v-card>
    <v-card tile flat width="100%" :min-width="minWidth" :max-width="maxWidth" class="pa-5 mx-auto">
      <div :class="$vuetify.breakpoint.smAndDown ? 'f12' : 'f14'">
        <slot name="title" />
      </div>
      <div class="ba" :class="$vuetify.breakpoint.smAndDown ? 'f12' : 'f14'" :style="totalResponsible ? 'width: 700px' : ''">
        <div class="salary_show_helper">
          <slot />
        </div>
      </div>
      <div v-if="$slots.button || $slots.button_responsible" class="grid">
        <div />
        <div />
        <div class="grid_inner">
          <div />
          <div />
          <div class="pt-2">
            <slot name="button"></slot>
          </div>
          <div/>
          <div/>
          <div/>
          <div class="pt-2">
            <slot name="button_responsible"></slot>
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'FinanceSalarySliceShowTable',
  props: {
    period: {
      type: Object,
      default: () => {
        return {}
      },
    },
    employee: {
      type: String,
      default: null,
    },
    totalResponsible: Boolean,
  },
  data: () => ({
    minWidth: 1800,
    maxWidth: 3000,
  }),
 computed: {
    formattingTerms() {
      let result = ''
      let pointIndex = this.period.term.indexOf('.')
      if (pointIndex === 4) {
        let dates = this.period.term.split(' - ')
        if (dates[0]) {
          const [year, month, day] = dates[0].split('.')
          dates[0] = `${day}.${month}.${year}`
        }
        if (dates[1]) {
          const [year, month, day] = dates[1].split('.')
          dates[1] = `${day}.${month}.${year}`
        }
        if (dates[0] && dates[1] && dates[0] > dates[1]) {
          dates = [dates[1], dates[0]]
        }
        result = dates.join(' - ')
      } else {
        result = this.period.term
      }
      return result
    },
  },
}
</script>

<style scoped lang="scss">
.salary_show_helper {
  :deep() .cell:not(.v-input) {
    position: relative;
    min-height: 24px;
    min-width: 32px;
    padding: 4px 6px;
    border: 1px solid #ebebeb !important;
    display: flex;
    align-items: center;
    overflow: hidden;
  }
  :deep() .responsibleCell {
    background-color: #F4F4F4;
  }
  .v-text-field {
    margin: 0 !important;
    padding: 0 !important;
  }

  :deep() .v-text-field input {
    padding: 4px 0 !important;
  }

  :deep() .v-text-field:not(.visible) .v-input__control {
    border-radius: 0 !important;
    height: 100% !important;
  }

  :deep() .v-input .v-input__slot:not(.v-textarea) fieldset {
    color: #ebebeb !important;
  }

  :deep() .v-input.v-text-field .v-input__slot:not(.v-textarea) {
    min-height: 30px !important;
  }

  :deep()
    .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
    > .v-input__control
    > .v-input__slot {
    padding: 0 4px !important;
  }
}

.b {
  &a {
    border: 1px solid #ebebeb;
  }

  &t {
    border-top: 1px solid #ebebeb;
  }

  &r {
    border-right: 1px solid #ebebeb;
  }

  &b {
    border-bottom: 1px solid #ebebeb;
  }

  &l {
    border-left: 1px solid #ebebeb;
  }
}

:deep() .grid {
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: 70px 250px 1fr;
  &_header {
    @extend .grid;
    grid-template-columns: 70px 250px 672px 438px 1fr;
    background-color: #f2f2f2;
  }
  &_header_no_responsible {
    @extend .grid;
    grid-template-columns: 70px 250px 672px 1fr;
    background-color: #f2f2f2;
  }
  &_responsible_header{
    @extend .grid;
    max-width: 700px;
    grid-template-columns: 300px 200px 200px;
    background-color: #f2f2f2;
    border: none !important;
  }
  &_responsible_inner {
    @extend .grid;
    grid-template-columns: 300px 200px 200px;
  }
  &_inner {
    @extend .grid;
    grid-template-columns: 120px 168px 144px 120px 120px 120px 138px 180px 1fr;
  }
 &_responsible_total_inner {
   @extend .grid;
   grid-template-columns: 120px 168px 144px 120px 120px 1fr;
 }
  &_days {
    @extend .grid;
    grid-template-columns: 70px 1fr;
  }
  &_days_inner {
    @extend .grid;
    grid-template-columns: 250px 120px 168px 144px 120px 120px 120px 138px 180px 1fr;
  }
  &_days_responsible_inner {
    @extend .grid;
    grid-template-columns: 250px 120px 168px 144px 120px 120px 1fr;
  }
  .grid_quantity {
    display: grid;
    grid-template-columns: 1fr 1.4fr 1.2fr 1fr 1fr;
  }
  .grid_row {
    display: grid;
    grid-template-rows: 1fr 1fr;
  }
  .grid_charge {
    display: grid;
    grid-template-columns: 1fr 1.15fr 1.5fr;
  }
}
:deep() .responsible_header_cell {
  background-color: #E4E4E4;
}
:deep() .grid_days_inner_note {
  display: grid !important;
  grid-template-rows: auto;
  grid-template-columns: 2fr 1fr;
}

.employee {
  display: grid;
  grid-template-columns: auto 250px auto 150px auto 1fr;
  grid-column-gap: 6px;
}

</style>
